document.addEventListener('DOMContentLoaded', () => {
    const burger = document.querySelector('.js-menu-open');
    const mobileNav = document.querySelector('.site-header__mobile-nav');

    if (!burger || !mobileNav) return;

    function openMenu() {
        mobileNav.classList.add('is-open');
        mobileNav.setAttribute('aria-hidden', 'false');
        burger.setAttribute('aria-expanded', 'true');
        document.body.style.overflow = 'hidden';
    }

    function closeMenu() {
        mobileNav.classList.remove('is-open');
        mobileNav.setAttribute('aria-hidden', 'true');
        burger.setAttribute('aria-expanded', 'false');
        document.body.style.overflow = '';
    }

    burger.addEventListener('click', openMenu);

    document.querySelectorAll('.js-menu-close').forEach(el => {
        el.addEventListener('click', closeMenu);
    });

    document.addEventListener('keydown', e => {
        if (e.key === 'Escape' && mobileNav.classList.contains('is-open')) {
            closeMenu();
        }
    });
});

document.addEventListener("DOMContentLoaded", function () {
    const header = document.querySelector('.site-header');

    if (!header) return;

    // The transparent state relies on a dark hero sitting behind the header.
    // Pages that open with light content get the glass background from the start.
    if (!document.querySelector('.hero, .sub-hero')) {
        header.classList.add('site-header--solid');
    }

    const scrollThreshold = 80;
    let ticking = false;

    // The nav links and the CTA are shared components, so their tone is carried by
    // their own modifier class rather than overridden from the header.
    const navLinks = header.querySelectorAll('.site-header__nav-link');
    const cta = header.querySelector('.site-header__cta');

    function setTone(isLight) {
        navLinks.forEach(link => link.classList.toggle('btn-nav--on-dark', !isLight));
        if (cta) cta.classList.toggle('btn--on-dark', !isLight);
    }

    function updateHeader() {
        const scrolled = window.scrollY > scrollThreshold;
        header.classList.toggle('site-header--scrolled', scrolled);
        setTone(scrolled || header.classList.contains('site-header--solid'));
        ticking = false;
    }

    window.addEventListener('scroll', function () {
        if (!ticking) {
            requestAnimationFrame(updateHeader);
            ticking = true;
        }
    }, { passive: true });

    updateHeader();
});

document.addEventListener("DOMContentLoaded", function () {
    if (document.querySelector('#top-bar-countdown')) {
        function topBarCountdown() {
            const countdownEl = document.querySelector('#top-bar-countdown');

            if (!countdownEl || !countdownEl.dataset.end) return;

            const endTime = new Date(countdownEl.dataset.end).getTime();

            function updateCountdown() {
                const now = new Date().getTime();
                const distance = endTime - now;

                if (distance <= 0) {
                    countdownEl.innerText = 'Promocja zakończona';
                    return;
                }

                const days = Math.floor(distance / (1000 * 60 * 60 * 24));
                const hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((distance % (1000 * 60)) / 1000);

                let result = '';
                if (days > 0) result += `${days} dni `;
                result += `${hours} godz. ${minutes} min. ${seconds} sek`;

                countdownEl.innerText = result;
            }

            updateCountdown();
            setInterval(updateCountdown, 1000);
        }

        topBarCountdown();
    }

    // Sticky navigation
    function initStickyNav() {
        const nav = document.querySelector('.header__nav');
        if (!nav) return;

        let lastScrollY = window.scrollY;
        let isSticky = false;
        let ticking = false;

        function updateStickyNav() {
            const scrollY = window.scrollY;
            const scrollThreshold = 100;
            const scrollDirection = scrollY > lastScrollY ? 'down' : 'up';

            if (scrollY > scrollThreshold && !isSticky) {
                nav.classList.add('sticky');
                nav.classList.remove('sticky-remove');
                isSticky = true;
            } else if (scrollY <= scrollThreshold && isSticky) {
                if (scrollDirection === 'up') {
                    nav.classList.add('sticky-remove');
                    nav.classList.remove('sticky');
                    
                    setTimeout(() => {
                        nav.classList.remove('sticky-remove');
                        isSticky = false;
                    }, 200);
                }
            }

            lastScrollY = scrollY;
            ticking = false;
        }

        function requestTick() {
            if (!ticking) {
                requestAnimationFrame(updateStickyNav);
                ticking = true;
            }
        }

        window.addEventListener('scroll', requestTick, { passive: true });
    }

    initStickyNav();

});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".mega-menu__wrapper").forEach(wrapper => {
        let data;
        try {
            data = JSON.parse(wrapper.dataset.menu || "[]");
        } catch (e) {
            console.error("JSON error:", e);
            return;
        }

        const col1 = wrapper.querySelector(".js-col-1");
        const col2 = wrapper.querySelector(".js-col-2");
        const col3 = wrapper.querySelector(".js-col-3");
        const col4 = wrapper.querySelector(".js-col-4");

        function renderList(container, items, level) {
            container.innerHTML = "";
            items.forEach(item => {
                const li = document.createElement("li");
                li.className = "mega-menu__list--item";

                const label = item.title || item.post_title || "—";
                let linkContent = label;

                if (item.image && item.image.url) {
                    linkContent = `<img src="${item.image.url}" alt="${label}" class="mega-menu__item-image">`;
                }

                li.innerHTML = `<a href="${item.url}">${linkContent}</a>`;
                container.appendChild(li);

                if (item.children && item.children.length > 0 && level < 4) {
                    li.addEventListener("mouseenter", () => {
                        renderList(wrapper.querySelector(`.js-col-${level + 1}`), item.children, level + 1);

                        for (let l = level + 2; l <= 4; l++) {
                            wrapper.querySelector(`.js-col-${l}`).innerHTML = "";
                        }

                        autoOpenFirstChild(item.children, level + 1);
                    });
                }
            });
        }

        function autoOpenFirstChild(items, level) {
            if (!items || items.length === 0 || level > 4) return;

            const nextCol = wrapper.querySelector(`.js-col-${level}`);
            renderList(nextCol, items, level);

            const first = items[0];
            if (first.children && first.children.length > 0) {
                autoOpenFirstChild(first.children, level + 1);
            }
        }

        renderList(col1, data, 1);
        if (data[0] && data[0].children) {
            autoOpenFirstChild(data[0].children, 2);
        }
    });
});

document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".simple-mega-menu__wrapper").forEach(wrapper => {
        let data;
        try {
            data = JSON.parse(wrapper.dataset.menu || "[]");
        } catch (e) {
            console.error("Simple mega menu JSON error:", e);
            return;
        }

        const leftList = wrapper.querySelector(".js-sml-left");
        const rightList = wrapper.querySelector(".js-sml-right");

        if (!leftList || !rightList) return;

        const arrowSvg = `<span class="sml-arrow"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>`;

        const rightPanel = rightList.closest(".simple-mega-menu__right");

        function renderRight(items) {
            rightList.innerHTML = "";
            items.forEach(item => {
                const li = document.createElement("li");
                li.className = "simple-mega-menu__list--item";
                li.innerHTML = `<a href="${item.url}">${item.title}</a>`;
                rightList.appendChild(li);
            });
            rightPanel.classList.add("is-visible");
        }

        const leftItems = [];

        data.forEach(item => {
            const li = document.createElement("li");
            li.className = "simple-mega-menu__list--item";
            const hasChildren = item.children && item.children.length > 0;
            li.innerHTML = `<a href="${item.url}">${item.title}${hasChildren ? arrowSvg : ""}</a>`;
            leftList.appendChild(li);
            leftItems.push({ el: li, item });

            li.addEventListener("mouseenter", () => {
                leftItems.forEach(({ el }) => el.classList.remove("active"));
                if (hasChildren) {
                    li.classList.add("active");
                    renderRight(item.children);
                } else {
                    rightList.innerHTML = "";
                    rightPanel.classList.remove("is-visible");
                }
            });
        });

        wrapper.closest(".simple-mega-menu").addEventListener("mouseleave", () => {
            leftItems.forEach(({ el }) => el.classList.remove("active"));
            rightList.innerHTML = "";
            rightPanel.classList.remove("is-visible");
        });
    });
});


document.addEventListener("DOMContentLoaded", () => {
    const searchModal = document.querySelector('.js-search-modal');
    const searchModalToggle = document.querySelector('.js-search-modal-toggle');
    const searchModalCloses = document.querySelectorAll('.js-search-modal-close');

    if (!searchModal || !searchModalToggle) return;

    searchModalToggle.addEventListener('click', () => {
        searchModal.classList.add('active');
        document.body.classList.add('blocked');
        const input = searchModal.querySelector('.search-modal__input');
        if (input) {
            setTimeout(() => input.focus(), 100);
        }
    });

    searchModalCloses.forEach((el) => {
        el.addEventListener('click', () => {
            searchModal.classList.remove('active');
            document.body.classList.remove('blocked');
        });
    });

    document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && searchModal.classList.contains('active')) {
            searchModal.classList.remove('active');
            document.body.classList.remove('blocked');
        }
    });
});
